import api from "../../../api/axios";

const fetchAllUsers = async () => {
  try {
    const response = await api.get("/api/users");

    return response.data;
  } catch (error) {
    console.error("fetchAllUsers", error);
    return undefined;
  }
};

const fetchUser = async (username) => {
  try {
    const response = await api.get(`/api/users/${username}`);

    return response.status === 200 ? response.data : undefined;
  } catch (error) {
    console.error("fetchUser error: ", error);
    return undefined;
  }
};

const addUser = async (username, firstname, lastname, role) => {
  try {
    const response = await api.post("/api/users", {
      username,
      firstname,
      lastname,
      role,
    });

    return response.status === 201 ? response.data : undefined;
  } catch (error) {
    console.error("addUsers error: ", error);
    return undefined;
  }
};

const removeUser = async (username) => {
  try {
    const response = await api.delete(`/api/users/${username}`);

    return response.status === 200;
  } catch (error) {
    console.error("removeUser error: ", error);
    return false;
  }
};

const resetUser = async (username) => {
  try {
    const response = await api.get(`/api/users/${username}/resetpassword`);

    return response.status === 200 ? response.data : undefined;
  } catch (error) {
    console.error("resetUser error: ", error);
    return undefined;
  }
};

export default {
  fetchAllUsers,
  fetchUser,
  addUser,
  removeUser,
  resetUser,
};
